import _debounce from "lodash/debounce";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { onCloseBoxBuilderPopup, saveBoxName, saveEditedBoxName, selectBackButton, typeBoxName } from '../../../../../redux/box-builder/box-builder.actions';
import { canGoBackwardsSelector, hasUnsavedChangesSelector, isEditingBoxNameBoxIdSelector, selectedOrExistedBoxNameSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import BoxNaming from './box-naming';
const mapStateToProps = createStructuredSelector({
  boxName: selectedOrExistedBoxNameSelector,
  isEdit: isEditingBoxNameBoxIdSelector,
  canGoBackwards: canGoBackwardsSelector,
  hasUnsavedChanges: hasUnsavedChangesSelector
});
const mapDispatchToProps = dispatch => {
  const debouncedDispatchBoxName = _debounce(name => {
    dispatch(typeBoxName(name));
  }, 250);
  return {
    onClose: onCloseBoxBuilderPopup(dispatch),
    onBackButton: () => {
      dispatch(selectBackButton(STEPS.BOX_NAMING));
    },
    onChange: name => {
      debouncedDispatchBoxName(name);
    },
    onSave: (name, isEdit) => {
      dispatch(saveBoxName(name));
      if (isEdit) {
        dispatch(saveEditedBoxName());
      }
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BoxNaming);